namespace advisorop.components.advisor {

    class InvestorCrudController 
    {
        $router;
        cuinvestor: CuInvestorController; 
        model: domains.IInvestor;
        entityTypeDescription: string = "";
        entityName: string = "";
        
        static $inject = ["advisorService", "generalService", "$scope"];
        constructor(private advisorService: services.AdvisorService, private generalService: services.GeneralService, private $scope: ng.IScope) {
            this.model = {};
            //console.log(this.$scope);
            this.$scope.$watchGroup(["vm.model.entityName", "vm.model.firstName", "vm.model.lastName"], () => {
                if (this.model.investorType == domains.InvestorType.INDIVIDUAL) {
                    this.entityTypeDescription = "INDIVIDUAL";
                    this.entityName = `${this.model.firstName} ${this.model.lastName}`;
                } else {
                    this.entityName = `${this.model.entityName}`;
                    this.generalService.getLOVs()
                        .then(data => {
                            let tmp = data.filter(f => f.lovType == domains.LovType.ENTITY_TYPE && f.value == this.model.entityType)[0];
                            if (tmp) {
                                this.entityTypeDescription = tmp.name;
                            } else {
                                this.entityTypeDescription = "Entity";
                            }
                        });
                }
            });
        };
        
        onCuInvestorInitialised(me: advisor.CuInvestorController) {
            this.cuinvestor = me;
        };
        
        loadInvestor(investorId: number): void {

            this.advisorService.getInvestor(investorId, false)
                .then((response) => {
                    this.model = response.data;
                })
                .catch((response) => {
                    console.log("Error during load individual", response.data);
                });
        }
        
        onCreateInvestor(investor: domains.IInvestor) {
            let that = this;
            this.cuinvestor.working = true;
            this.advisorService.createInvestor(investor)
                .then(function (response) {
                    toastr.success("Investor successfully created.");
                    that.cuinvestor.investorCreatedOrUpdated(response.data);
                    window.history.back();
                })
                .catch((response) => {
                    toastr.error("Error " + response.status + " : " + response.data);
                })
                .finally(() => {
                    that.cuinvestor.working = false;
                });
        };

        onUpdateInvestor(investor: domains.IInvestor) {
            let that = this;
            this.cuinvestor.working = true;
            this.advisorService.updateInvestor(investor)
                .then(data => {
                    toastr.success("Investor successfully modified.");
                    that.cuinvestor.investorCreatedOrUpdated(data.data);
                    window.history.back();
                })
                .catch(err => {
                    toastr.error(`Error ${err.status}: ${err.data}`);
                })
                .finally(() => {
                    that.cuinvestor.working = false;            
                });
        };

        onCancelInvestor() {
            window.history.back();
        };

        

        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
            if (next.params.investorId)
                this.loadInvestor(<number>next.params.investorId);
         
        }
        
    }


    class InvestorCrud implements ng.IComponentOptions
    {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        $canActivate;

        constructor() {
            this.controller = InvestorCrudController;
            this.controllerAs = "vm";
            this.bindings = {
                $router: "<",
            };
            this.templateUrl = "spa/advisor-module/views/investor-crud.html";
            this.$canActivate = ["advisorService", (advisorService: services.AdvisorService) => {
                if (advisorService.isAdminModeEnabled()) {
                    toastr.info("Please exit from Admin Mode to enable create/edit investor");
                    return false;
                }
                return true;
            }];
        }

    }
    angular.module(Constants.APP).component("investorCrud", new InvestorCrud());


}